function s(t) {
  const e = {}, r = [];
  return t.reduce((u, n) => e[n.id] ? u : (e[n.id] = !0, [...u, n]), r);
}
function i(t) {
  return t.sort((e, r) => new Date(r.inserted_at).getTime() - new Date(e.inserted_at).getTime());
}
export {
  s as deduplicateItems,
  i as sortItems
};
//# sourceMappingURL=utils.mjs.map
